import { useContext, useEffect, useState } from 'react';
import { ApiHubCardDataContext } from '../../../Contexts/ApiHubCardDataContext';



export const ApiHubTotalData = () => {
  const { apiResponse } = useContext(ApiHubCardDataContext);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (apiResponse) {
      setIsLoading(false);
    }
  }, [apiResponse]);
  if (isLoading) {
    return [];
  }

  return [
    {
      title: "Total Users",
      count: apiResponse.data.userCount
    },
    {
      title: "Total APIs",
      count: apiResponse.data.approvedApiCount ?? 0
    },
    {
      title: "Contributing Projects",
      count: apiResponse.data.approvedProjects ?? 0
    }

  ];
};
